module.exports = __webpack_public_path__ + "static/media/1.cbe5e729.png";